const ROC_STATE = {
  mumbai: 'Maharashtra', pune: 'Maharashtra',
  ahmedabad: 'Gujarat',
  delhi: 'Delhi', 'nct of delhi': 'Delhi',
  bangalore: 'Karnataka', bengaluru: 'Karnataka',
  chennai: 'Tamil Nadu', coimbatore: 'Tamil Nadu',
  hyderabad: 'Telangana', telangana: 'Telangana',
  kolkata: 'West Bengal',
  jaipur: 'Rajasthan',
  chandigarh: 'Chandigarh', 'himachal pradesh': 'Himachal Pradesh',
  kanpur: 'Uttar Pradesh',
  patna: 'Bihar',
  cuttack: 'Odisha',
  ernakulam: 'Kerala',
  gwalior: 'Madhya Pradesh',
  guwahati: 'Assam',
  goa: 'Goa',
  shillong: 'Meghalaya',
  jammu: 'Jammu and Kashmir',
  vijayawada: 'Andhra Pradesh',
  jharkhand: 'Jharkhand',
  uttarakhand: 'Uttarakhand',
  chhattisgarh: 'Chhattisgarh',
};

/** "ROC Hyderabad" → "Telangana". '' when the office is unknown or unmapped. */
export function rocToState(roc) {
  const r = String(roc || '').toLowerCase().replace(/^roc[\s-]*/, '').trim();
  if (!r) return '';
  // Longest key first: 'himachal pradesh' must beat nothing, but a short key
  // like 'goa' must not win inside a longer office name.
  const keys = Object.keys(ROC_STATE).sort((a, b) => b.length - a.length);
  for (const k of keys) if (r.includes(k)) return ROC_STATE[k];
  return '';
}

const hasRows = (v) => Array.isArray(v) && v.length > 0;

export function deriveProfileFromRegistry(form = {}) {
  const out = {};

  const state = rocToState(form.roc || form.rocOffice);
  if (state && !hasRows(form.establishments)) {
    out.establishments = [{
      label: 'Registered office',
      state,
      city: '',
      type: 'registered-office',
      employeeCount: '',
      esiEligibleCount: '',
      commencedOn: form.incorporated || '',
      closedOn: '',
      isFactory: false,
      pollutionCategory: '',
      pollutionCategorySource: 'declared',
    }];
  }

  const sub = String(form.subCategory || '').toLowerCase();

  if (form.isGovernmentCompany === null || form.isGovernmentCompany === undefined) {
    if (/non[-\s]?government/.test(sub)) out.isGovernmentCompany = false;
    else if (/govt|government/.test(sub)) out.isGovernmentCompany = true;
  }

  if ((form.isSubsidiaryCompany === null || form.isSubsidiaryCompany === undefined)
    && /subsidiary/.test(sub)) {
    out.isSubsidiaryCompany = true;
  }

  const listed = String(form.listed || '');
  if (!hasRows(form.exchanges) && /^yes/i.test(listed.trim())) {
    const ex = [];
    if (/BSE/i.test(listed)) ex.push('BSE');
    if (/NSE/i.test(listed)) ex.push('NSE');
    if (ex.length) out.exchanges = ex;
  }

  return out;
}

export function describeDerivations(patch = {}) {
  const lines = [];
  if (patch.establishments) {
    lines.push(`${patch.establishments[0].state} registered office`);
  }
  if (patch.isGovernmentCompany === false) lines.push('Government company: No');
  if (patch.isGovernmentCompany === true) lines.push('Government company: Yes');
  if (patch.isSubsidiaryCompany === true) lines.push('Subsidiary company: Yes');
  if (patch.exchanges) lines.push(`Listed on ${patch.exchanges.join(' and ')}`);
  return lines;
}

export { ROC_STATE };
